import React, { type JSX } from 'react'
import { SushiSwapProtocol } from 'sushi/evm'

export const ProtocolBadge: Partial<Record<SushiSwapProtocol, JSX.Element>> = {
  [SushiSwapProtocol.SUSHISWAP_V3]: (
    <div className="whitespace-nowrap bg-blue/20 text-blue text-[10px] px-2 rounded-full">
      V3
    </div>
  ),
  [SushiSwapProtocol.BLADE]: (
    <div className="whitespace-nowrap bg-blue/20 text-blue text-[10px] px-2 rounded-full">
      BLADE
    </div>
  ),
}
